import { render, staticRenderFns } from "./SQuesTwenty.vue?vue&type=template&id=643d40aa&"
import script from "./SQuesTwenty.vue?vue&type=script&lang=js&"
export * from "./SQuesTwenty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports